export default __webpack_public_path__ + "static/media/recuadroUno.6710b35a.png";